import { BsEye, BsEyeSlash } from 'react-icons/bs'
import { useTranslation } from 'react-i18next'
import { AppLink, AppSpan, AppText, Button, Form } from 'src/style'
import { TextField, Box } from 'src/componentv2'
import { LoginInput } from './types'

interface LoginFormProps {
    input: LoginInput
    set: (key: keyof LoginInput) => (value: string) => void
    fieldError: (key: keyof LoginInput) => string | undefined
    showPassword: boolean
    setShowPassword: (value: boolean) => void
    handleLogin: (e?: React.FormEvent<HTMLButtonElement | HTMLFormElement>) => void
    onForgotPassword: () => void
}

const LoginForm: React.FC<LoginFormProps> = ({
                                                 input, set, fieldError, showPassword, setShowPassword, handleLogin, onForgotPassword
                                             }) => {
    const { t } = useTranslation()

    return (
        <>
            <AppText
                color='#101828' textSize='3' fontWeight='600' bottomPadding='0.7'
                className='login-title'
            >
                {t('login.title')}
            </AppText>
            <AppSpan
                color='#667085' textSize='1.6'
                className='login-instruction'
            >
                {t('login.subtitle')}
            </AppSpan>

            <Form onSubmit={handleLogin}>
                <Box topMargin="2.4">
                    <TextField
                        label={t('login.institutionCodeLabel')}
                        placeholder={t('login.institutionCodePlaceholder')}
                        value={input.ibInstitutionCode}
                        onChange={set('ibInstitutionCode')}
                        type="number"
                        error={fieldError('ibInstitutionCode')}
                    />
                </Box>

                <Box topMargin="1.6">
                    <TextField
                        label={t('login.usernameLabel')}
                        placeholder={t('login.usernamePlaceholder')}
                        value={input.userID}
                        onChange={set('userID')}
                        error={fieldError('userID')}
                    />
                </Box>

                <Box topMargin="1.6" style={{ position: 'relative' }}>
                    <TextField
                        label={t('login.passwordLabel')}
                        placeholder={t('login.passwordPlaceholder')}
                        type={showPassword ? 'text' : 'password'}
                        value={input.password}
                        onChange={set('password')}
                        error={fieldError('password')}
                    />
                    <span
                        style={{
                            position: 'absolute',
                            right: '1.6rem',
                            top: '3.8rem',
                            cursor: 'pointer',
                            color: 'rgba(0, 0, 0, 0.5)',
                            fontSize: '1.7rem'
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        { showPassword ? <BsEye/> : <BsEyeSlash/> }
                    </span>
                </Box>

                <Button
                    width='100' sizeUnit='%'
                    titleSize='1.6' fontWeight='600'
                    height='4.4' radius='0.8'
                    topMargin='3.5' bottomMargin='3.5' hoverColor='#0D968F'
                    hoverBgColor='#fff' borderColor='#0D968F'
                >
                    {t('login.loginButton')}
                </Button>

                <AppText align='center'>
                    <AppLink
                        decoration='none' color='#1E1E1E'
                        fontWeight='600' hoverColor='#0D968F'
                        onClick={onForgotPassword}
                    >
                        {t('login.forgotPassword')}
                    </AppLink>
                </AppText>
            </Form>
        </>
    )
}

export default LoginForm